module.exports = __webpack_public_path__ + "img/bottom.1ac099bc.gif";